import React from 'react'
import { Link } from 'react-router'

import { DataCard, RedBadge } from '../data-card/data-card-parts'

const AreaCard = ({
  area = {},
  latestHistory = {},
  technician,

  linkUrlBase
}) => {
  let issueCountBadge = null

  if (area.issueCount > 0) {
    const issuesText = area.issueCount === 1 ? 'issue' : 'issues'
    issueCountBadge = <RedBadge text={`${area.issueCount} ${issuesText}`} />
  }

  return (
    <DataCard>
      <Link to={`${linkUrlBase || ''}/areas/${area.id}`}>
        <p><strong>{area.name}</strong> {issueCountBadge}</p>
        <p>Last cleaning: {(latestHistory.services || []).join(', ') || '—'}</p>
        {technician && <p className='small'>Cleaned by: {technician.name} on {latestHistory.completedAt.format('MMMM D, YYYY')}</p>}
      </Link>
    </DataCard>
  )
}

export default AreaCard



// WEBPACK FOOTER //
// ./src/components/areas/area-card.js